import { Component, effect, inject, NgZone } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { ErrorService } from 'errors/error.service';
import { SpinnerComponent, ToasterComponent, ToastService } from 'ng-components-tsi';
import { filter, take } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToasterComponent, SpinnerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})

export class AppComponent {

  private toastService = inject(ToastService)
  private errorService = inject(ErrorService)
  private router = inject(Router)
  private ngZone = inject(NgZone)

  constructor() {
    effect(() => {
      const error = this.errorService.appError()
      if (error) this.toastService.error('Error App', error)
    })
    this.ngZone.runOutsideAngular(() => this.initLoader())
  }

  private initLoader(): void {
    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      take(1)
    ).subscribe(() => {
      this.ngZone.onStable.pipe(take(1)).subscribe(() => this.hideLoader())
    })
  }

  private hideLoader(): void {
    const loader = document.getElementById('initial-loader')
    if (!loader) return
    loader.style.transition = 'opacity 0.4s ease'
    loader.style.opacity = '0'
    setTimeout(() => loader.style.display = 'none', 420)
  }
}